import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Mansioni } from 'src/app/models/mansioni';
import notify from 'devextreme/ui/notify';
@Injectable({
  providedIn: 'root',
})
export class MansioniService {
  mansioniUrl = environment.ildatoArticoliDpi + 'api/mansioni';
  private http = inject(HttpClient);

  private _listMansioni = new BehaviorSubject<Mansioni[] | undefined>(undefined);

  list(): Observable<Mansioni[]> {
    return this.http.get<Mansioni[]>(this.mansioniUrl);
  }

  listTemp(forceRefresh: boolean = false): Observable<Mansioni[]> {
    if (
      this._listMansioni.value == undefined ||
      forceRefresh
    ) {
      this.http.get<Mansioni[]>(this.mansioniUrl).subscribe({
        next: (res) => {
          this._listMansioni.next(res);
        },
        error: (err) => {
          if (err?.error?.title) {
            notify(err.error.title, 'error');
          } else {
            notify('Errore recupero lista mansioni', 'error');
          }
        },
      });
    }

    return this._listMansioni.asObservable().pipe(filter((r) => r != null));
  }

  get(id: number): Observable<Mansioni> {
    return this.http.get<Mansioni>(this.mansioniUrl + '/' + id);
  }

  insert(values: Mansioni): Observable<Mansioni> {
    return this.http.post<Mansioni>(this.mansioniUrl, values);
  }

  remove(idMansione: number): Observable<Mansioni> {
    return this.http.delete<Mansioni>(this.mansioniUrl + '/' + idMansione);
  }

  update(key: number, values: Mansioni): Observable<Mansioni> {
    return this.http.put<Mansioni>(this.mansioniUrl + '/' + key, values);
  }

  cleanTemp(){
    this._listMansioni.next(undefined);
  }
}
